let chevron = null;

export default function () {
    const tables = $('.sort-table');

    chevron = document.createElement('i');
    chevron.classList.add("material-icons");

    tables.toArray().forEach(table => bindTableHeaderClick(table));
}

function bindTableHeaderClick(table) {
    table = $(table);
    const headers = table.find('th');

    headers.click(function () {
        const headerIndex = $('.sort-table th').index(this);
        const previousIndex = parseInt(table.attr('data-index'));
        const descending = headerIndex === previousIndex;

        // keep track of the previous column clicked to toggle descending
        // set it to null if we flip to descending to flip back to ascending
        table.attr('data-index', (descending ? null : headerIndex));
        sortTableByColumn(table, headerIndex, descending);
        displaySortIndicator(headers, headerIndex, descending);
    });
}

function displaySortIndicator(headers, headerIndex, descending = false) {
    const header = headers[headerIndex];

    chevron.textContent = "keyboard_arrow_" + (descending ? "up" : "down");
    header.append(chevron);
}

function sortTableByColumn(table, columnIndex, descending = false) {
    const rows = table.find('tbody tr').toArray();
    const sorted = rows.sort((r1, r2) => {
        const comparison = r1.cells[columnIndex].textContent > r2.cells[columnIndex].textContent;
        return descending ? !comparison : comparison;
    });

    table.append(sorted);
}